import StoreUtils from "../../../services/Store/StoreUtils";
import {ConfigApi, OrderSchedulingMode} from "../../../services/Api/types";

export const anyMenuHasPickDate = (menus: any[], orderType: string | undefined) => {
    return menus.some((menu: any) => !orderType || (menu[orderType.toLowerCase()] === true && menu.pick_date));
}

export const isAnotherDateAvailable = (config: ConfigApi | undefined, menus: Record<string, any>[], orderType: string | undefined) => {
    const orderSchedulingMode = StoreUtils.getOrderSchedulingMode(config);

    return (orderSchedulingMode === OrderSchedulingMode.SAME_DAY || orderSchedulingMode === OrderSchedulingMode.ENABLED) && anyMenuHasPickDate(menus, orderType);
}